import "../styles/Header.css"
import * as React from 'react';

import Button from '@mui/material/Button';
import { Icon } from "@mui/material";
import fatihdurmaz from "../resources/fatihdurmaz.pdf"


const Header = (props) => {
    return (
        <div className="header-box">
            
            <Button className="icon-button"href="https://www.youtube.com/watch?v=dQw4w9WgXcQ&ab_channel=RickAstley">
            FD
            </Button>
            <Icon/>
            <ul className="header-buttons">
                <Button className="header-button" onClick={props.scrollAbout}>About</Button>
                <Button className="header-button" onClick={props.scrollXp}>Experiences</Button>
                <Button className="header-button" href={fatihdurmaz} target = "_blank">Resume</Button>
            </ul>
        </div>)
}

export default Header